import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import MainHeader from "../../components/Layouts/MainHeader";
import PricingFilter from "./PricingFilter";
import CustomLoader from "../../components/custom-loader";
import MainContent from "../../components/Layouts/MainContent";
import uparrowFilter from "../../assets/uparrowFilter.svg";
import downarrowFilter from "../../assets/downarrowFilter.svg";
import PricingSummaryTable from "./PricingSummaryTable";
import PricingOpportunityGraph from "./PricingOpportunityGraph";
import { Box, FormControlLabel, Switch } from "@mui/material";
import { Button, Input } from "rsuite";
import useFilter from "../../hooks/useFilter";
import { filterDefaultValues } from "./PricingFilterConfig";
import GreenSwitch from "../../components/common/Switch";
import { useLocation } from "react-router-dom";


const Pricing = () => {
	const [graphRequestData, setGraphRequestData] =
		useState<PricingGraphRequest | null>(null);
	const searchRef = useRef<PricingSearchRef>(null);
	const { selectedFilter } = useFilter();
	const [pricingSelectedFilterValues, setPricingSelectedFilterValues] =
		useState<any>(filterDefaultValues[selectedFilter]);
	const [opportunity, setOpportunity] = useState<PricingMinMaxopportunity>({
		min: "",
		max: "",
	});
	const [loader, setLoader] = useState<number>(0);
	const [isFilterExpanded, setIsFilterExpanded] = useState<boolean>(true);

	const handleSearch = (isAfterUpdateAction?: boolean) => {
		searchRef.current?.executeSearch(isAfterUpdateAction);
	};

	const [mainContentHeight, setMainContentHeight] = useState(0);
	const ref1 = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const handleResize = () => {
			if (ref1.current)
				setMainContentHeight(
					window.innerHeight -
					ref1.current.offsetTop -
					ref1.current.offsetHeight
				);
		};
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [isFilterExpanded]);

	const loctaionValue = useLocation();
	useEffect(() => {
		const searchedCustomer = new URLSearchParams(loctaionValue.search).get(
			"customer"
		);

		if (searchedCustomer && selectedFilter == "electrical") {
			setPricingSelectedFilterValues((prev: any) => ({ ...prev, "bill_customer_id": [searchedCustomer] }))
		}
	}, []);
	return (
		<>
			<div ref={ref1}>
				<MainHeader customClass="relative" headerName="Pricing">
					<div className={`${isFilterExpanded ? "block" : "hidden"}`}>
						<div className={`w-full `}>
							<div className="flex justify-between">
								<div className="flex justify-start items-center gap-[1vw] pb-[2vh]">
									<PricingFilter
										pricingSelectedFilterValues={
											pricingSelectedFilterValues
										}
										handlePricingFilterValueChange={
											setPricingSelectedFilterValues
										}
										setLoading={setLoader}
									/>
								</div>
								<div className="flex gap-x-[1vw] justify-start text-[0.7vw] mb-2 items-center">
									{selectedFilter === "electrical" &&
										<>
											<div className="filter-header font-bold">
												Opportunity:
											</div>
											<Input
												placeholder="From"
												type="number"
												className="px-[1vh] w-[8vw]  text-black rounded-md text-[0.7vw]"
												onChange={(value: string) => {
													setOpportunity((prev) => ({
														...prev,
														min: value,
													}));
												}}
												value={opportunity.min}
											/>
											<Input
												placeholder="To"
												type="number"
												className="px-[1vh] w-[8vw]  text-black rounded-md text-[0.7vw]"
												onChange={(value: string) => {
													setOpportunity((prev) => ({
														...prev,
														max: value,
													}));
												}}
												value={opportunity.max}
											/>
											<Button
												onClick={() => handleSearch()}
												type="button"
												className="btn-text !bg-deloitteGreen w-[10vh] !text-white">
												Search
											</Button>
										</>}
									{selectedFilter === "plumbing" && <>
										<FormControlLabel
											control={
												<GreenSwitch checked={pricingSelectedFilterValues?.home || false} onChange={(e) => { setPricingSelectedFilterValues((prev: any) => ({ ...prev, home: e.target.checked })) }} />
											}
											label="Exclude Non-Home"
										/>
									</>}
								</div>
							</div>
						</div>
						<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
							<img
								className="w-[1.5vw]"
								src={uparrowFilter}
								alt="upArrow"
								onClick={() => {
									setIsFilterExpanded(false);
								}}
							/>
						</div>
					</div>

					<div
						className={` ${isFilterExpanded ? "hidden" : "flex"
							} justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer`}
					>
						<img
							className="w-[1.5vw]"
							src={downarrowFilter}
							alt="upArrow"
							onClick={() => {
								setIsFilterExpanded(true);
							}}
						/>
					</div>
				</MainHeader>
			</div>
			<MainContent fullHeight={!isFilterExpanded}>
				<Box
					className="flex gap-[1%]"
					sx={{
						height: `calc(${mainContentHeight}px - 12vh)`,
					}}
				>
					<div className="shrink-0 grow-1 basis-[55%]  ">
						<PricingSummaryTable
							filterValues={pricingSelectedFilterValues}
							setLoader={setLoader}
							setOpportunity={setOpportunity}
							ref={searchRef}
							opportunity={opportunity}
							setGraphRequestData={setGraphRequestData}
						/>
					</div>
					<div className="shrink-0 grow-1 basis-[45%] ">
						<PricingOpportunityGraph
							graphRequestData={graphRequestData}
							setLoader={setLoader}
							filterValues={pricingSelectedFilterValues}
							handleSearch={handleSearch}
						/>
					</div>
				</Box>
			</MainContent>
			<CustomLoader open={loader > 0} />
		</>
	);
};

export default Pricing;
